export const SET_SEARCH_TEXT = 'search_realtors/set_search_text' as const;

export const setSearchText = (payload: string) => ({
  type: SET_SEARCH_TEXT,
  payload,
});

export type TSetSearchTextPayload = Parameters<typeof setSearchText>;
export type TSetSearchTextAction = ReturnType<typeof setSearchText>;
